import { Component, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';

import { Survey } from '@app/interface/survey';
import { SurveyAnswer } from '@app/interface/surveyAnswer.model';
import { UserService } from '@app/services/user.service';
import { SurveyAnswerService } from '@app/surveyAnswers/surveyAnswers.service';

@Component({
  selector: 'app-usersurvey-table',
  templateUrl: './userSurvey.component.html',
  styleUrls: ['./userSurvey.component.scss'],
})
export class UserSurveyTableComponent implements OnChanges {
  @Input() isLoading: boolean;
  @Input() message: string;
  @Input() dataTable: SurveyAnswer[];
  dataColumn: any[] = ['surveyId', 'startAt', 'endAt', 'status', 'completePercentage'];
  @Output() surveyDetailEvent = new EventEmitter<Survey>();
  first = 0;
  rows = 5;
  values = '';
  surveyData: any[] = [];

  constructor(public userService: UserService, public surveyAnswerService: SurveyAnswerService) {}

  getIndex(arr: any, activity: any) {
    let index = arr.map((item: any) => item.id).indexOf(activity['id']);
    return index;
  }

  ngOnChanges(change: SimpleChanges) {
    this.getSurveyData(change);
  }

  public getSurveyData(change: SimpleChanges): void {
    if (change && change.dataTable) {
      this.isLoading = change.isLoading.currentValue;
      this.dataTable = change.dataTable.currentValue;
    } else {
      this.surveyData = [];
    }
  }

  getSelectedUserSurveyQuestion(survey: any): void {
    this.surveyDetailEvent.emit(survey);
  }

  getSurveyQuestionData(uuid: string) {
    this.surveyAnswerService.getUserSurveyName(uuid).subscribe((survey: any) => {
      return survey.name;
    });
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }
}
